import React, { useState, useMemo, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { IState } from "../../redux/reducers/rootReducers";
import CommonStyles from "../common/CommonStyles";
import { Link } from "react-router-dom";
import LogoutOutlinedIcon from "@mui/icons-material/LogoutOutlined";
import Home from "./../../assest/icons/menu/home.svg";
import {
  Box,
  Divider,
  Drawer,
  List,
  ListItem,
  ListItemIcon,
} from "@mui/material";
import { DoLogOutAction } from "../../redux/actions/Login/Login";
import { storeAllResponses } from "../../redux/actions/TicketsManagement/TicketsManagement";
import { theme } from "../../redux/actions/Theme/Theme";
import logoImg from "./../../assest/icons/logo.png";
import ConfirmationNumberOutlined from "@mui/icons-material/ConfirmationNumberOutlined";
import ApprovalIcon from "@mui/icons-material/Approval";
import { useMsal } from "@azure/msal-react";
import HandIcon from "../../assest/ssp/hand.svg";
import WorkIcon from "../../assest/ssp/work.svg";
import ApplicationIcon from "../../assest/ssp/application.svg";
import bulbIcon from "../../assest/ssp/bulb.svg";
import ChatIcon from "../../assest/ssp/chat.svg";
import SideDrawer from "../common/sideDrawer";
import whatsappIcon from "./../../assest/emojis/whatsapp-icon.svg";
import teamIcon from "./../../assest/emojis/teams.svg";
import emailIcon from "./../../assest/emojis/email-icon.svg";
import phoneIcon from "./../../assest/emojis/Phone-icon.svg";
import ScreenShare from "../SceenShare/ScreenShare";
import useScreenRecording from "../SceenShare/useScreenRecording";
import { getContactById } from "../../pages/contact-us/ContactUsAPI";

const drawerWidth = 200;

const SideNavbarSSP: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const classes = CommonStyles();
  // const [ChatDrawerstate, setChatDrawerstate] = useState<boolean>(false);
  const currAgent = useSelector(
    (state: IState) => state?.agentReducer?.loggedInAgent
  );
  const defaultService:any = useSelector((state: IState) => state?.ContactsReducer?.DefaultService);
  function isActive(pathname: string) {
    return false;
  }
  const { instance } = useMsal();
  function LogOut() {
    if(instance.logout) instance.logout();
    dispatch(theme(false));
    localStorage.clear();
    dispatch(DoLogOutAction());
    dispatch(storeAllResponses({}));
    navigate("/");
  }
  const closeMenu = () => {
    const bodyTag = document.getElementsByTagName("body");
    bodyTag[0].classList.remove("menuOpened");
  };
  const SideNavSSPIcon = (props: any) => {
    const { imgSrc, className, style } = props;
    return (
      <>
          <Box className={`dark-icon ${className || ""}`} >
            <img src={imgSrc} alt="" style={{...style}}/>
          </Box>
      </>
    );
  };
  const [chatDrawerState, setChatDrawerState] = useState(false);
  const openChatDrawer = () => setChatDrawerState(true);
  const closeChatDrawer = () => setChatDrawerState(false);
  const { startRecording, stopRecording } = useScreenRecording();
  const iconStyle = {
    width: "17px",
    height: "24px",
  };
  const containerStyle: any = {
    display: "flex",
    flexDirection: "column",
    gap: "10px",
    padding: "15px 15px 0px 15px",
  };
  const [contactInfo, setContactInfo] = useState<any>({
    emailRows: [],
    phoneRows: [],
    whatsapp: "",
    teamUrl: "",
  });

  useEffect(() => {
    const fetchContactInfo = async () => {
      try {
        const res = await getContactById();
        if (res) {
          setContactInfo({
            emailRows: JSON.parse(res.email) || [],
            phoneRows: JSON.parse(res.mobilePhone) || [],
            whatsapp: res.whatsAppNumber,
            teamUrl: res.teamsId,
          });
        }
      } catch (error) {
        console.error("Failed to fetch contact information:", error);
      }
    };
    fetchContactInfo();
  }, []);

  return (
    <>
    <Drawer
      variant="permanent"
      className={`${classes.mainSideHolder} sidebarHolder`}
    >
      <div className={classes.mainSideBar}>
        <div>
          <Link to="/" className="sidebarLogo">
            <img src={logoImg} alt="" />
            <span></span>
          </Link>
        </div>
        <Divider />
        <List>
          <Link to="/home">
            <ListItem className={[isActive("/") ? "active" : ""].join(" ")}>
              <ListItemIcon id="homeIcon">
                <img src={Home} alt="" />
                <span>Home</span>
              </ListItemIcon>
            </ListItem>
          </Link>
          <Link to={defaultService?.id ? `/viewService?id=${defaultService.id}` :"/viewService"}>
            <ListItem
              className={[isActive("#/CMDB") ? "active" : ""].join(" ")}
            >
              <ListItemIcon id="newTicIcon">
                <Box className='icon-shadow'>
                  <ConfirmationNumberOutlined/>
                </Box>
                <span>
                  New <br /> Ticket
                </span>
              </ListItemIcon>
            </ListItem>
          </Link>
          <Link to="/MyTaskApproval">
            <ListItem
              className={[isActive("#/MyTaskApproval") ? "active" : ""].join(" ")}
            >
              <ListItemIcon id="newTicIcon">
                <Box className='icon-shadow'>
                  <ApprovalIcon />
                </Box>
                <span>
                  My <br /> Approvals
                </span>
              </ListItemIcon>
            </ListItem>
          </Link>
          
          {/* Request Service */}
          <Link to="/viewService">
            <ListItem
              className={[isActive("#/viewService") ? "active" : ""].join(" ")}
            >
              <ListItemIcon id="newTicIcon">
                <SideNavSSPIcon imgSrc={HandIcon} className="ssp-nav-iconHolder thick" />
                <span>
                  Request <br /> Service
                </span>
              </ListItemIcon>
            </ListItem>
          </Link>

          {/* Work Center */}
          <Link to="/workCenter">
            <ListItem
              className={[isActive("#/workCenter") ? "active" : ""].join(" ")}
            >
              <ListItemIcon id="newTicIcon">
                <SideNavSSPIcon imgSrc={WorkIcon} className="ssp-nav-iconHolder thick" />
                <span>
                  Work <br /> Center
                </span>
              </ListItemIcon>
            </ListItem>
          </Link>

          {/* My Assets */}
          <Link to="/myAssets">
            <ListItem
              className={[isActive("#/myAssets") ? "active" : ""].join(" ")}
            >
              <ListItemIcon id="newTicIcon">
                <SideNavSSPIcon imgSrc={ApplicationIcon} className="ssp-nav-iconHolder thick" />
                <span>
                  My <br /> Assets
                </span>
              </ListItemIcon>
            </ListItem>
          </Link>

          {/* Knowledge Share */}
          <Link to="/ArticlesSSP">
            <ListItem
              className={[isActive("#/ArticlesSSP") ? "active" : ""].join(" ")}
            >
              <ListItemIcon id="newTicIcon">
                <SideNavSSPIcon imgSrc={bulbIcon} className="ssp-nav-iconHolder thick" style={{height: "34px", width: "31px"}}  />
                <span>
                  Knowledge <br /> Share
                </span>
              </ListItemIcon>
            </ListItem>
          </Link>

          {/* Contact Us - Not Needed */}
            <ListItem onClick={openChatDrawer} className={[isActive("#/contactUs") ? "active" : ""].join(" ")}>
              <ListItemIcon id="newTicIcon">
                <SideNavSSPIcon imgSrc={ChatIcon} className="ssp-nav-iconHolder thick" />
                <span>
                  Contact <br /> Us
                </span>
              </ListItemIcon>
            </ListItem>
          
        </List>
        <Divider />
        <Box className={`md-none ${classes.sideLogoutBtn}`} onClick={LogOut}>
          <LogoutOutlinedIcon />
          <span>logout</span>
        </Box>
      </div>
      <span onClick={closeMenu} className={classes.menuClose}></span>
    </Drawer>
    <SideDrawer
          width="572px"
            onClose={closeChatDrawer}
            drawerState={chatDrawerState}
            anchor={"right"}
            title="Contact Us"
          >
            <div style={containerStyle}>
              {/* <ScreenShare
                startRecording={startRecording}
                stopRecording={stopRecording}
                screen={true}
                audio={true}
                video={true}
              /> */}
              {contactInfo.emailRows.length > 0 &&
                contactInfo.emailRows.map((email: any, index: any) => (
                  <a key={index} href={`mailto:${email?.email}`} className="SSP-home-Links">
                    <img
                      src={emailIcon}
                      alt="Email Icon"
                      style={iconStyle}
                    />{" "}
                    {email.name && `${email.name} - `}
                    <span style={{ fontSize: "14px", color: "#555" }}>
                      {email.email}
                    </span>
                  </a>
                ))}
              {contactInfo.phoneRows.length > 0 &&
                contactInfo.phoneRows.map((phone: any, index: any) => (
                  <a key={index} href={`tel:${phone.phone}`} className="SSP-home-Links">
                    <img
                      src={phoneIcon}
                      alt="Phone Icon"
                      style={iconStyle}
                    />{" "}
                    {phone.name && `${phone.name} - `}
                    <span style={{ fontSize: "14px", color: "#555" }}>
                      {phone.phone}
                    </span>
                  </a>
                ))}
              {contactInfo.teamUrl && (
                <a
                  href={contactInfo.teamUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="SSP-home-Links"
                >
                  <img
                    src={teamIcon}
                    alt="Team Icon"
                    style={{ width: "22px", height: "24px" }}
                    />{" "}
                  Team's Call
                </a>
              )}
              {contactInfo.whatsapp && (
                <a href={`https://wa.me/${contactInfo.whatsapp}`} className="SSP-home-Links">
                  <img
                    src={whatsappIcon}
                    alt="WhatsApp Icon"
                    style={{ width: "22px", height: "24px" }}
                    />{" "}
                  WhatsApp us
                </a>
              )}
    
              {/* <a
                href="#"
                className="SSP-home-Links disabled"
              >
                <img
                  src={Bot}
                  alt="Email Icon"
                  style={{ width: "22px", height: "24px" }}
                />{" "}
                Chat now (Not available)
              </a> */}
            </div>
    </SideDrawer>
    </>
  );
};

export default SideNavbarSSP;
